<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <DoctorQueueTable
      permission-key="other_patients"
      endpoint="/theaterpatients"
      action-path="/theatertreatment"
      action-label="Treatment"
      no-permission-text="You have no permission to View Theater Patients"
    />
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DoctorQueueTable from "@/components/DoctorQueueTable.vue";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Theater Patients",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, DoctorQueueTable },
  data() {
    return {
      title: "Theater Patients",
      items: [{ text: "Dashboard", to: "/" }, { text: "Theater Patients", active: true }],
    };
  },
};
</script>
